import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=196e0c1f&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"
import style0 from "./Background.vue?vue&type=style&index=0&id=196e0c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e0c1f",
  null
  
)

export default component.exports